import { createContext, createMemo, useContext } from "solid-js";
import Icon from "../st-icon/st-icon";
import styles from './st-spinner.module.css'

type Size = "small" | "medium"

class StSpinnerProps {
    size?: Size = "medium"
}

export default function StSpinner(props: StSpinnerProps) {
    return <StSpinnerInner {...props} />
}
StSpinner.defaultProps = new StSpinnerProps();

function StSpinnerInner(props: StSpinnerProps) {
    return <div class={styles.spinner} attr:spinner-size={props.size}>
        <Icon src="fa-solid fa-spinner" spin={true} />
    </div>
}
